import clsx from "clsx";

import { LoadingSlide } from "@components/title-slide-view";

export const Loading = () => {
  return (
    <div
      className={clsx(
        "flex flex-col items-center justify-center h-full w-full left-0 top-0 z-50",
        "overflow-hidden absolute",
      )}
    >
      <LoadingSlide />
    </div>
  );
};
